// extracted by mini-css-extract-plugin
module.exports = {"key-moments":"styles-module__key-moments___16fOW"};